import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "table table-striped" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, "Nazione"),
    /*#__PURE__*/_createElementVNode("td", null, "Simbolo valuta"),
    /*#__PURE__*/_createElementVNode("td", null, "Codice valuta (x stripe)"),
    /*#__PURE__*/_createElementVNode("td", null, "Prezzo (iva inclusa)"),
    /*#__PURE__*/_createElementVNode("td", null, "% iva"),
    /*#__PURE__*/_createElementVNode("td", null, "Punti")
  ])
], -1)
const _hoisted_3 = ["onUpdate:modelValue"]
const _hoisted_4 = ["onUpdate:modelValue"]
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = ["onUpdate:modelValue"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nazioniAttive, (item, i) => {
        return (_openBlock(), _createElementBlock("tr", { key: i }, [
          _createElementVNode("td", null, _toDisplayString(item.alpha2Code), 1),
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              placeholder: "Simbolo",
              "onUpdate:modelValue": ($event: any) => ((_ctx.localValue[item.alpha2Code.toLowerCase()].simbolo) = $event)
            }, null, 8, _hoisted_3), [
              [_vModelText, _ctx.localValue[item.alpha2Code.toLowerCase()].simbolo]
            ])
          ]),
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              placeholder: "Codice valuta",
              "onUpdate:modelValue": ($event: any) => ((_ctx.localValue[item.alpha2Code.toLowerCase()].currency) = $event)
            }, null, 8, _hoisted_4), [
              [_vModelText, _ctx.localValue[item.alpha2Code.toLowerCase()].currency]
            ])
          ]),
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": ($event: any) => ((_ctx.localValue[item.alpha2Code.toLowerCase()].importo) = $event)
            }, null, 8, _hoisted_5), [
              [_vModelText, _ctx.localValue[item.alpha2Code.toLowerCase()].importo]
            ])
          ]),
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": ($event: any) => ((_ctx.localValue[item.alpha2Code.toLowerCase()].vatPerc) = $event)
            }, null, 8, _hoisted_6), [
              [_vModelText, _ctx.localValue[item.alpha2Code.toLowerCase()].vatPerc]
            ])
          ]),
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              class: "form-control",
              "onUpdate:modelValue": ($event: any) => ((_ctx.localValue[item.alpha2Code.toLowerCase()].punti) = $event)
            }, null, 8, _hoisted_7), [
              [_vModelText, _ctx.localValue[item.alpha2Code.toLowerCase()].punti]
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}